const contentKeys = {
  active: "active",
  inactive: "inactive",
  composing: "composing",
};

export default contentKeys;
